import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin, Phone } from "lucide-react";

export function Footer() {
  return (
    <footer className="bg-[#2A4B3C] text-white" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 md:grid-cols-4 md:px-10">
        <div className="md:col-span-2">
          <div className="mb-6 inline-flex">
            <img
              data-testid="footer-brand-logo-image"
              src="/images/brand/tatva-hills-logo-transparent.png"
              alt="Tatva Hills Farm Fresh logo"
              className="h-12 w-auto object-contain brightness-0 invert md:h-14"
            />
          </div>
          <p data-testid="footer-brand-name" className="sr-only">Tatva Hills Farm Fresh</p>
          <p data-testid="footer-brand-line" className="max-w-md text-lg leading-relaxed text-white/75">
            Tatva Hills Farm Fresh — Pure harvests from Uttarakhand, grown with purpose.
          </p>
        </div>
        <div>
          <p className="mb-4 text-sm font-semibold uppercase tracking-[0.18em] text-white/50">Navigate</p>
          <div className="flex flex-col gap-3 text-white/80">
            {["Shop", "Our Story", "Farmers & Impact", "Natural Farming", "Contact"].map((label) => {
              const to = label === "Farmers & Impact" ? "/farmers-impact" : `/${label.toLowerCase().replaceAll(" & ", "-").replaceAll(" ", "-")}`;
              return <Link data-testid={`footer-link-${label.toLowerCase().replaceAll(" & ", "-").replaceAll(" ", "-")}`} key={label} to={to} className="transition-colors hover:text-white">{label}</Link>;
            })}
          </div>
        </div>
        <div>
          <p className="mb-4 text-sm font-semibold uppercase tracking-[0.18em] text-white/50">Contact</p>
          <div className="space-y-3 text-white/80">
            <p data-testid="footer-location" className="flex gap-3"><MapPin className="mt-1 h-4 w-4" /> Tatva Hills, Uttarakhand</p>
            <p data-testid="footer-email" className="flex gap-3"><Mail className="mt-1 h-4 w-4" /> care@tatvahillsagro.com</p>
            <p data-testid="footer-phone" className="flex gap-3"><Phone className="mt-1 h-4 w-4" /> +91 92660 19419</p>
            <a data-testid="footer-instagram-link" href="https://www.instagram.com/project.tatvahills" className="inline-flex items-center gap-2 transition-colors hover:text-white"><Instagram className="h-4 w-4" /> Instagram</a>
          </div>
        </div>
      </div>
    </footer>
  );
}